<template>
  <v-card >
       <v-dialog v-model="dialogRemoveRoute" persistent width="600">
      <v-card class="text-center">
        <v-card-title>
         <p class="text-md-left">{{$t("deleteconfirm")}} <b style="color:red;font-size:16px;">{{newRoute.nr_ref}}</b></p>
        </v-card-title>
        <v-card-actions>
           <v-btn
            color="black"
            text
            @click="dialogRemoveRoute = false"
          >
            {{$t("close")}}
          </v-btn>
          <v-btn
           @click="cancels"
            color="red"
            
          >
            {{$t("anulacja")}}
          </v-btn>
        </v-card-actions>
      </v-card>
     </v-dialog>
   </v-row>
   <div class="text-center">
    <v-dialog v-model="dialog" persistent width="600">
      <v-card>
        <v-card-title class="pb-0 mb-0 justify-center">
          <span class="headline">{{$t('addroute')}}</span>
        </v-card-title>
        <v-card-text class="pb-0 mb-0 pt-0 mt-0">
          <v-container>
            <v-form
            v-model="valid">
   <!-- ZIEJSCE ZALADUNKU -->
             <v-flex xs12>
                   <v-autocomplete
                  :items="itemsPlaces"
                  item-text="place_key"
                  v-model="newRoute.from_key"
                  label="Skąd"
                  block
                  required
                ></v-autocomplete>
              </v-flex>
 <!-- MIEJSCE ROZLADUNKU -->
             <v-flex xs12>
             <v-autocomplete
                  :items="itemsPlaces"
                  item-text="place_key"
                  v-model="newRoute.to_key"
                  label="Do"
                  required
                ></v-autocomplete>   
              </v-flex>

 <!-- NUMER REFERENCYJNY -->
             <v-flex xs12>
                <v-text-field
                  label="Numer referencyny"
                  v-model="newRoute.nr_ref"
                  required
                ></v-text-field>
              </v-flex>

<!-- DATA ODJAZDU -->
     <v-flex xs12>  
      <v-menu
        ref="menu2"
        v-model="menu2"
        :close-on-content-click="false"
        :return-value.sync="newRoute.dateLeft"
        transition="scale-transition"
        offset-y
        full-width
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="newRoute.dateLeft"
            label="Data odjazdu"
            readonly
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker   locale="pl" v-model="newRoute.dateLeft" no-title scrollable>
          <div class="flex-grow-1"></div>
          <v-btn text color="primary" @click="menu2 = false">{{$t('close')}}</v-btn>
          <v-btn text color="primary" @click="$refs.menu2.save(newRoute.dateLeft)">OK</v-btn>
        </v-date-picker>
      </v-menu>
   </v-flex>

 <!-- CZAS ODJAZDU -->
     <v-flex xs12>
      <v-menu
        ref="menu3"
        v-model="menu3"
        :close-on-content-click="false"
        :nudge-right="40"
        :return-value.sync="newRoute.timeLeft"
        transition="scale-transition"
        offset-y
        full-width
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="newRoute.timeLeft"
            label="Czas Odjazdu"
            readonly
            v-on="on"
          ></v-text-field>
        </template>
        <v-time-picker
          v-if=""
          v-model="newRoute.timeLeft"
          full-width
          format="24hr"
          @click:minute="$refs.menu3.save(newRoute.timeLeft)"
        ></v-time-picker>
      </v-menu>
    </v-flex>

        <!-- DATA PRZYJAZDU -->
    <v-flex xs12>
      <v-menu
        ref="menu0"
        v-model="menu0"
        :close-on-content-click="false"
        :return-value.sync="newRoute.dateArrive"
        transition="scale-transition"
        offset-y
        locale="pl"
        full-width
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="newRoute.dateArrive"
            label="Data przyjazdu"
            readonly
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker  locale="pl" v-model="newRoute.dateArrive" no-title scrollable>
          <div class="flex-grow-1"></div>
          <v-btn text color="primary" @click="menu0 = false">{{$t('close')}}</v-btn>
          <v-btn text color="primary" @click="$refs.menu0.save(newRoute.dateArrive)">OK</v-btn>
        </v-date-picker>
      </v-menu>
   </v-flex>
 <!-- CZAS PRZYJAZDU -->
    <v-flex xs12>
      <v-menu
        ref="menu1"
        v-model="menu1"
        :close-on-content-click="false"
        :nudge-right="40"
        :return-value.sync="newRoute.timeArrive"
        transition="scale-transition"
        offset-y
        full-width
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="newRoute.timeArrive"
            label="Czas przyjazdu"
            readonly
            v-on="on"
          ></v-text-field>
        </template>
        <v-time-picker
          v-if=""
          format="24hr"
          v-model="newRoute.timeArrive"
          full-width
          @click:minute="$refs.menu1.save(newRoute.timeArrive)"
        ></v-time-picker>
      </v-menu>
   </v-flex>

          <!-- CARS -->
            <v-flex xs12>
                <v-autocomplete
                  :items="itemsCars"
                  item-text="nr_rej"
                  v-model="newRoute.id_car"
                  label="Ciężarówka"
   
                ></v-autocomplete>
              </v-flex>
            </v-row>
                 </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn  color="blue darken-4" text @click="( () => { dialog = false;setTimeout(()=>{this.newRoute = {};},500)})">{{$t("close")}}</v-btn>
          <v-btn @click="sendRoute" color="blue darken-1" :disabled="!valid" text >{{$t("save")}}</v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>
  </div>
    <v-toolbar  dense color="transparent">
      <v-toolbar-title>
        <!-- DATA START -->
        <v-layout row wrap>
     <v-flex xs6>
       <v-menu
        ref="menu5"
        v-model="menu5"
        :close-on-content-click="false"
        :return-value.sync="startData"
        transition="scale-transition"
        offset-y
        full-width
        min-width="250px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="startData"
            readonly
            text
            class="mt-2"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker  locale="pl" v-model="startData" no-title scrollable>
          <div class="flex-grow-1"></div>
          <v-btn text color="primary" @click="menu5 = false">{{$t('close')}}</v-btn>
          <v-btn text color="primary" @click="$refs.menu5.save(startData)">OK</v-btn>
        </v-date-picker>
      </v-menu>
    </v-flex>
<!-- DATA KONIEC -->
    <v-flex xs6>
      <v-menu
        ref="menu6"
        v-model="menu6"
        :close-on-content-click="false"
        :return-value.sync="endData"
        transition="scale-transition"
        offset-y
        full-width
        min-width="200px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="endData"
            readonly
            class="mt-2"
            v-on="on"
            width="100px"
          ></v-text-field>
        </template>
        <v-date-picker  locale="pl" v-model="endData" no-title scrollable>
          <div class="flex-grow-1"></div>
          <v-btn text color="primary" @click="menu6 = false">{{$t('close')}}</v-btn>
          <v-btn text color="primary" @click="$refs.menu6.save(endData)">OK</v-btn>
        </v-date-picker>
      </v-menu>
    </v-flex>
        </v-layout>   
        </v-toolbar-title>
          <v-btn class="ml-2" @click="searchRoutes" small color="red">Szukaj</v-btn>
          <v-btn small class="ml-2" @click="print">Drukuj</v-btn>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-divider></v-divider>
    <v-card-text class="pa-0 mt-2 mb-2 ml-2" id="printMe">
      {{startData}} - {{endData}} ||
      Ładunków:  {{count}}
      <template>
        <v-data-table  hide-default-footer :mobile-breakpoint='200'  :search="searchtext" item-key="id" no-data-text="Brak rekordów" :items-per-page=1000 :headers="headers" :items="historyRoutes" class="elevation-0" >

         <template v-slot:item.timeleft="{ item }">
         <td  class="text-xs-left" style="color:green"><div style="color:green" >{{item.dateLeft}}</div>{{item.timeleft }}</td>
           </template>

           <template v-slot:item.timearrive="{ item }">
          <td  class="text-xs-left"><div >{{item.dateArrive}}</div>{{item.timearrive}}</td>
           </template>

              <template v-slot:item.status="{ item }">
               <div v-if="item.cancel =='1'" class="caption">ANULACJA</div>
           </template>

           <template v-if="editon" v-slot:item.action="{ item }">
         <div class="text-xs-center">
              <v-btn @click="updates(item)"  v-if="item.cancel !='1' && !deleteon" small text icon color="grey">
                <v-icon>edit</v-icon>
              </v-btn>

              <v-btn  @click="deles(item)" v-if="item.cancel !='1'" small text icon color="red">
                <v-icon>remove</v-icon>
              </v-btn>
              <v-btn  @click="removes(item)" text small icon ><v-icon>delete_outline</v-icon></v-btn>
            </div>
           </template>
        </v-data-table>
      </template>
      <v-divider></v-divider>
    </v-card-text>
  </v-card>
</template>
<script>
const axios = require('axios');
import moment from 'moment'
export default {
  computed: {
    routes() {
      return this.store.state.routes
    },
    search() {
      return this.store.state.searchtext
    },
    allcars(){
      return this.store.state.allcars
    },
     places(){
      return this.store.state.places;
    },
  },
  watch:{
    search:{ handler: function(newValue) {
      this.searchtext = newValue
      },
      deep: true
    },
     places: {
      handler: function(newValue) {
      this.itemsPlaces = newValue;

      },
      deep: true
    },
    routes: {
      handler: function(newValue,oldValue) {
      this.itemsRoutes = newValue;
      },
      deep: true
    },
     allcars: {
      handler: function(newValue,oldValue) {
      this.itemsCars = newValue;
      },
      deep: true
    },
     dataNow(value){
      this.store.state.dateNow = this.dataNow;
     }
  },

  mounted(){
     this.dataNow = new Date().toISOString().substr(0, 10);
     this.refresh();
},
methods: {
  refresh(){
  var data = this;
  var jwt = this.getCookie('jwt');
  axios.post('http://' + location.hostname + '/transportapp/php_file/validation_token.php', {
           jwt : jwt,
           date : data.dataNow,
           sortby:'country'
    })
  .then(function (response) {
    if ( response.data.message == "access" ){
      data.store.state.routes = JSON.parse( response.data.routes );
      data.store.state.cars   = JSON.parse( response.data.cars );
      data.store.state.places = JSON.parse( response.data.places );
        data.store.state.allcars = JSON.parse(response.data.allcars);
    } else if ( response.data.message == "denied" ) {
        data.$router.push('/auth/login');
        
    }
  })
 },
   print() {
      this.searchRoutes();
      this.editon=false;
    setTimeout( () => {this.$htmlToPaper('printMe');this.editon=true;},1000);
  },
  converttime(salut) {
    let now = moment().utc();
    let arrive = moment(salut.time_arrive)
    let left =  moment(salut.time_left)
     let  alltimedrive = left.diff(arrive,'hours');
     let realtimedrive = now.diff(left,'hours');
      if(realtimedrive>0)return  Math.abs(Math.floor( realtimedrive / alltimedrive  * 100))
        else return 0
  },
  getCookie(cname){
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' '){
            c = c.substring(1);
        }
 
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
    },
    updates(route){
    this.newRoute = route;
    this.dialog=true;
    },

  deles(item){
   this.newRoute=item;
   this.dialogRemoveRoute = true;
},
  searchRoutes(){
  var data = this;
  var jwt = this.getCookie('jwt');
  axios.post('http://' + location.hostname + '/transportapp/php_file/getDataByRange.php', {
           jwt : jwt,
           startData : data.startData,
           endData : data.endData
    })
  .then(function (response) {
    if ( response.data.message == "access" ){
      data.historyRoutes = JSON.parse( response.data.historyroutes );
      data.count = data.historyRoutes.length;
    } else if ( response.data.message == "denied" ) {
        data.$router.push('/auth/login');
    }
  })
 },

removes(item){
     this.newRoute=item;
     var data=this;
     var jwt = this.getCookie('jwt');
     if(this.newRoute.id != null){

     axios.post('http://'+location.hostname+'/transportapp/php_file/delete.php', {
           jwt :jwt,
           data:data.newRoute
    })
     .then(function (response) {
      data.newRoute = {};
      data.dialogRemoveRoute = false;
      data.searchRoutes();
     })
     .catch(function (error) {
       console.log(error);
     });
   }
},

cancels(){
     var data=this;
     var jwt = this.getCookie('jwt');
     if(this.newRoute.id != null){

     axios.post('http://'+location.hostname+'/transportapp/php_file/cancel.php', {
           jwt :jwt,
           data:data.newRoute
    })
     .then(function (response) {
      data.newRoute = {};
        data.searchRoutes();
      data.dialogRemoveRoute = false;
     })
     .catch(function (error) {
       console.log(error);
     });
   }
},


  sendRoute(){
     var data=this;
     var jwt = this.getCookie('jwt');
     let datetimeArrive = this.newRoute.dateArrive+' '+this.newRoute.timeArrive+':00'
     let datetimeLeft = this.newRoute.dateLeft+' '+this.newRoute.timeLeft+':00'
     this.newRoute.time_arrive = datetimeArrive;
     this.newRoute.time_left = datetimeLeft;
     if(this.newRoute.id != null){
     axios.post('http://'+location.hostname+'/transportapp/php_file/update.php', {
           jwt :jwt,
           data: data.newRoute
          
    })
     .then(function (response) {
      data.newRoute = {};
      if(data.dialog)data.dialog = false;
     })
     .catch(function (error) {
       console.log(error);
     });
     }
    
  
},
},

  data() {
    return {
      dialog:false,
      startData:moment().format('YYYY-MM-DD'),
      endData:moment().format('YYYY-MM-DD'),
      dataNow:'',
      dialog:false,
      deleteon:false,
      editon:true,
      newRoute:{},
      menu1:false,
      menu2:false,
      menu3:false,
      menu4:false,
      menu5:false,
      menu6:false,
      itemsRoutes:this.store.state.routes || [],
      itemsCars: this.store.state.allcars || [],
      itemsPlaces: this.store.state.places || [],
      valid:false,
      historyRoutes:[],
      dialogRemoveRoute:false,
      menu0:false,
      count:0,
      searchtext:'',
      newRoute:{},
      headers: [
        {
          text: "Skąd",
          align: "left",
          value: "from_key"
        },
        {
          text: "Do",
          align: "left",
          value: "to_key"
        },
        { text: "Numer Referencyjny", value: "nr_ref", align: "left" },
        { text: "Czas Odjazdu", value: "time_left" },
        { text: "Czas Przyjazdu", value: "time_arrive" },
        { text: "Status", value:"status"},
        { text: "Pojazd", value: "id_car", align: "left" },
        { text: "Akcje", value: "action", align: "left" },
      ]
    }
  }
}
  
</script>
<style>


</style>
